import React from "react";
import { Navigate } from "react-router-dom";

import Page from "@jumbo/shared/Page";

import Login from "../pages/login";
import Dashboard from "app/pages/dashboard";
import MarcasProcessos from "app/pages/marcas/processos";
import CalculadoraPrazo from "app/pages/marcas/calculadora/CalculadoraPrazo";
import Usuarios from "app/pages/usuarios/Usuarios";
import UsuarioForm from "app/pages/usuarios/UsuarioForm";
import ClientesProcessos from "app/pages/clientes/processos";
import DetalhesProcesso from "app/pages/clientes/processos/DetalhesProcesso";
import AdminRoute from "./AdminRoute";
import OperadorRoute from "./OperadorRoute";
import DetalhesMarcaProcesso from "app/pages/marcas/processos/DetalhesMarcaProcesso";
import LogsDownloadsRPIs from "app/pages/logs-downloads-rpis";
import Envolvidos from "app/pages/envolvidos/Envolvidos";
import EnvolvidosForm from "app/pages/envolvidos/EnvolvidosForm";
import CadastroMarcasRPI from "app/pages/marcas/rpi/CadastroMarcasRPI";
import PatentesColidencias from "app/pages/patentes/colidencias/PatentesColidencias";
import Webseek from "app/pages/webseek/Webseek";
import Agenda from "app/pages/marcas/agenda";

const routesForPublic = [
  { path: "/", element: <Navigate to="/login" /> },
];

const routesForAuthenticatedOnly = [
  // Rotas para todos os usuários autenticados (CLIENTE, OPERADOR, ADMIN)
  {
    path: "/dashboard",
    element: <Page component={Dashboard} />,
  },
  {
    path: "/cliente/processos",
    element: <Page component={ClientesProcessos} />,
  },
  {
    path: "/cliente/processos/:id",
    element: <Page component={DetalhesProcesso} />,
  },
  // Rotas para OPERADOR e ADMIN
  {
    path: "/marcas/processos",
    element: <OperadorRoute component={MarcasProcessos} MainComponent={Page} />,
  },
  {
    path: "/marcas/processo/:id",
    element: <OperadorRoute component={DetalhesMarcaProcesso} MainComponent={Page} />,
  },  {
    path: "/marcas/rpi",
    element: <OperadorRoute component={CadastroMarcasRPI} MainComponent={Page} />,
  },  {
    path: "/marcas/colidencias",
    element: <OperadorRoute component={PatentesColidencias} MainComponent={Page} />,
  },
  {
    path: "/marcas/agenda",
    element: <OperadorRoute component={Agenda} MainComponent={Page} />,
  },
  {
    path: "/marcas/calculadora",
    element: <OperadorRoute component={CalculadoraPrazo} MainComponent={Page} />,
  },

  // Rotas apenas para ADMIN
  {
    path: "/usuarios",
    element: <AdminRoute component={Usuarios} MainComponent={Page} />,
  },
  {
    path: '/usuario',
    element: <AdminRoute component={UsuarioForm} MainComponent={Page} />
  },
  {
    path: "/usuario/:id",
    element: <AdminRoute component={UsuarioForm} MainComponent={Page} />,
  },
  {
    path: "/logs-rpis",
    element: <AdminRoute component={LogsDownloadsRPIs} MainComponent={Page} />,
  },
  {
    path: "/envolvidos",
    element: <OperadorRoute component={Envolvidos} MainComponent={Page} />,
  },
  {
    path: "/envolvido",
    element: <OperadorRoute component={EnvolvidosForm} MainComponent={Page} />,
  },
  {
    path: "/envolvido/:id",
    element: <OperadorRoute component={EnvolvidosForm} MainComponent={Page} />,
  },
  {
    path: "/marcas/busca",
    element: <OperadorRoute component={Webseek} MainComponent={Page} />,
  },
];

const routesForNotAuthenticatedOnly = [
  {
    path: "/login",
    element: (
      <Page component={Login} layout={"solo-page"} disableSmLogin={true} />
    ),
  },
];

const routesFallback = [
  { path: '*', element: <Navigate to="/" /> }
];

const routes = [
  ...routesForPublic,
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
  ...routesFallback
];

export {
  routes as default,
  routesForPublic,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
};
